import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      color: 'white',
      fontSize: 'xs',
      fontWeight: 'bold',
      caretColor: 'currentColor',
      fontFamily: 'accent',
      bg: 'transparent',

      '&&&': {
        boxShadow: 'none',
        border: 'none',
      },

      '&::placeholder': {
        color: 'whiteAlpha.700',
      },

      '&:hover': {
        '&&': {
          bg: 'transparent',
          borderLeft: 'none',
          color: 'beta.300',
        },
      },

      '&:focus, &:active': {
        '&&': {
          bg: 'transparent',
          border: 'none',
          color: 'beta.300',
          textShadow: '0px 0px 6px rgba(254, 196, 77, 0.6)',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontWeight: 'bold',
      fontSize: 'sm',
      fontFamily: 'accent',

      '&&': {
        mr: 0,
        bgGradient: 'linear(to-b, beta.300, beta.400)',
        color: 'blackAlpha.800',
        textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
        borderRadius: 'md',
        border: 'none',
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          '&&': {
            boxShadow: 'none',
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '35px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {
    size: 'md',
  },
};
